import { defineComponent as _defineComponent } from 'vue'
import LazyImage from 'Src/js/components/LazyImage.vue';
import { IListableProductJson } from 'JS/types/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoImage',
  props: {
    product: null
  },
  setup(__props: any) {




return { __sfc: true,LazyImage }
}

})